<div class="project-description">
<div class="h11">Project Notebook</div>
<!-- Welcome to my notebook -->
<p>
  Being a developer means being a superhero. It is not an easy road to take but in the 
  end we have to make the world a better place. The path is dark but our job is to make sure its not dark for other people 
  who cross the same path. We take such huge resposibility onto ourselves. It has never been an easy
  job. We need to be crazy and passionate about things noone thought and no-one tried to solve. Notebook 
  is a project which helps developers to build projects and collaborate with each other. I have made it 
  simpler for you so that noone else has to face the same problem.

</p>
</div>